import { styled } from "@mui/material/styles";

export const StyledContainer = styled("div")(({ theme }) => ({
  overflow: "scroll",
  position: "fixed",
  top: 190,
  right: 110,
  bottom: 68,
  left: 290,
  paddingBottom: 10
}));

export const StyledHeader = styled("div")(({ theme }) => ({
  paddingLeft: "40%"
}));
